// extracted by mini-css-extract-plugin
export default {"modalFooter":"ModalFooter_modalFooter__lZMmt"};